
document.addEventListener('DOMContentLoaded', function() {
  vyraeSplitPredictiveRows();

  const searchDrawer = document.getElementById('search-drawer');
  if (searchDrawer) {
    const observer = new MutationObserver(function() {
      vyraeSplitPredictiveRows();
    });
    observer.observe(searchDrawer, { childList: true, subtree: true });
  }

  window.addEventListener('resize', function() {
    vyraeSplitPredictiveRows();
  });
});

class AccountDrawerPanels extends HTMLElement {
  connectedCallback() {
    this._duration = 250;
    this._closeDelay = 350;
    this._closeResetTimer = null;

    this._drawer = this.closest('#account-drawer');

    this._onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;

      e.preventDefault();

      const panel = (a.getAttribute("href") || "").slice(1);
      if (!panel) return;

      this.show(panel);
    };

    this.addEventListener("click", this._onClick);

    this.show("login", { instant: true });

    if (this._drawer) {
      this._observer = new MutationObserver(() => {
        if (this._drawer.hasAttribute("open")) {
          this._cancelInternalReset();
          return;
        }

        this._scheduleInternalReset();
      });

      this._observer.observe(this._drawer, {
        attributes: true,
        attributeFilter: ["open"],
      });
    }

    // --- CHANGE: keep login inside drawer (AJAX submit; show errors in-drawer) ---
    this._loginForm = this.querySelector('form[action*="/account/login"]');

    this._ensureLoginErrorHolder = () => {
      let holder = this.querySelector("#account-drawer-login-error");
      if (!holder) {
        holder = document.createElement("div");
        holder.id = "account-drawer-login-error";

        const fieldset = this._loginForm && this._loginForm.querySelector(".fieldset");
        if (fieldset && fieldset.parentNode) {
          fieldset.parentNode.insertBefore(holder, fieldset.nextSibling);
        }
      }
      return holder;
    };

    this._extractLoginErrorHtml = (html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      const banner =
        doc.querySelector(".banner") ||
        doc.querySelector('[role="alert"]') ||
        doc.querySelector(".form__message") ||
        doc.querySelector(".errors") ||
        doc.querySelector("ul.errors");

      if (banner) return banner.outerHTML;

      return '<div class="banner banner--error" role="alert">Inloggen mislukt. Controleer je e-mail en wachtwoord.</div>';
    };

    this._onLoginSubmit = async (e) => {
      if (!this._loginForm) return;

      e.preventDefault();

      const errorHolder = this._ensureLoginErrorHolder();
      if (errorHolder) errorHolder.innerHTML = "";

      const formData = new FormData(this._loginForm);

      try {
        const res = await fetch(this._loginForm.action, {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Accept": "text/html",
          },
          redirect: "follow",
        });

        // Success usually redirects to /account — reload current page instead of navigating away
        if (res.redirected && !res.url.includes("/account/login")) {
          window.location.reload();
          return;
        }

        const text = await res.text();
        if (errorHolder) errorHolder.innerHTML = this._extractLoginErrorHtml(text);

        // Keep drawer open and stay on login view
        if (this._drawer) this._drawer.setAttribute("open", "");
        this.show("login", { instant: true });
      } catch (err) {
        const fallbackHolder = this._ensureLoginErrorHolder();
        if (fallbackHolder) {
          fallbackHolder.innerHTML =
            '<div class="banner banner--error" role="alert">Er ging iets mis met inloggen. Probeer het opnieuw.</div>';
        }

        if (this._drawer) this._drawer.setAttribute("open", "");
        this.show("login", { instant: true });
      }
    };

    if (this._loginForm) {
      this._loginForm.addEventListener("submit", this._onLoginSubmit);
    }
    // --- END CHANGE ---
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClick);
    if (this._observer) this._observer.disconnect();

    // --- CHANGE: cleanup login submit listener ---
    if (this._loginForm && this._onLoginSubmit) {
      this._loginForm.removeEventListener("submit", this._onLoginSubmit);
    }
    // --- END CHANGE ---
  }

  _scheduleInternalReset() {
    this._cancelInternalReset();

    this._closeResetTimer = window.setTimeout(() => {
      if (this._drawer && !this._drawer.hasAttribute("open")) {
        this.show("login", { instant: true });
      }
      this._closeResetTimer = null;
    }, this._closeDelay);
  }

  _cancelInternalReset() {
    if (!this._closeResetTimer) return;
    window.clearTimeout(this._closeResetTimer);
    this._closeResetTimer = null;
  }

  _animateSwap(fromEl, toEl, onMid) {
    if (!fromEl || !toEl || fromEl === toEl) {
      if (typeof onMid === "function") onMid();
      return;
    }

    fromEl.setAttribute("data-panel-state", "leaving");

    window.setTimeout(() => {
      if (typeof onMid === "function") onMid();

      toEl.hidden = false;
      toEl.setAttribute("data-panel-state", "entering");

      window.setTimeout(() => {
        toEl.removeAttribute("data-panel-state");
      }, 20);

      fromEl.hidden = true;
      fromEl.removeAttribute("data-panel-state");
    }, this._duration);
  }

  show(panelId, { instant = false } = {}) {
    const loginWrap = this.querySelector("#account-login-panel");
    const register = this.querySelector("#account-register-panel");
    const reset = this.querySelector("#account-reset-panel");

    if (!loginWrap || !register || !reset) return;

    const login = loginWrap.querySelector("#login");
    const recover = loginWrap.querySelector("#recover");

    const getVisibleRoot = () => {
      if (!register.hidden) return register;
      if (!reset.hidden) return reset;
      return loginWrap;
    };

    const currentRoot = getVisibleRoot();

    const targetRoot =
      panelId === "register" ? register :
      panelId === "reset" ? reset :
      loginWrap;

    const applyLoginInner = () => {
      if (!login || !recover) return;

      if (panelId === "recover") {
        if (instant) {
          login.hidden = true;
          recover.hidden = false;
          login.removeAttribute("data-panel-state");
          recover.removeAttribute("data-panel-state");
          return;
        }

        if (!login.hidden) {
          this._animateSwap(login, recover, () => {});
        } else {
          recover.hidden = false;
        }
        return;
      }

      if (instant) {
        recover.hidden = true;
        login.hidden = false;
        login.removeAttribute("data-panel-state");
        recover.removeAttribute("data-panel-state");
        return;
      }

      if (!recover.hidden) {
        this._animateSwap(recover, login, () => {});
      } else {
        login.hidden = false;
      }
    };

    if (instant) {
      loginWrap.hidden = true;
      register.hidden = true;
      reset.hidden = true;

      targetRoot.hidden = false;
      applyLoginInner();
      return;
    }

    if (currentRoot === targetRoot) {
      applyLoginInner();
      return;
    }

    this._animateSwap(currentRoot, targetRoot, () => {
      loginWrap.hidden = true;
      register.hidden = true;
      reset.hidden = true;

      targetRoot.hidden = false;
      applyLoginInner();
    });
  }
}

if (!window.customElements.get("account-drawer-panels")) {
  window.customElements.define("account-drawer-panels", AccountDrawerPanels);
}

class ReturnDrawerPanels extends HTMLElement {
  connectedCallback() {
    this._duration = 250;
    this._closeDelay = 350;
    this._closeResetTimer = null;

    this._drawer = this.closest("#return-drawer");
    this._form = this.querySelector("form#return-drawer-form");

    if (this._form) {
      this._form.setAttribute("novalidate", "novalidate");
    }

   this._onClick = (e) => {
  const trigger = e.target.closest('[data-panel],[href^="#"]');
  if (!trigger) return;

  e.preventDefault();

  let panel = trigger.getAttribute("data-panel");

  if (!panel) {
    panel = (trigger.getAttribute("href") || "").slice(1);
  }

  if (!panel) return;

  this.show(panel);
};

    this.addEventListener("click", this._onClick);

    this.show("start", { instant: true });

    if (this._drawer) {
      this._observer = new MutationObserver(() => {
        if (this._drawer.hasAttribute("open")) {
          this._cancelInternalReset();
          return;
        }
        this._scheduleInternalReset();
      });

      this._observer.observe(this._drawer, {
        attributes: true,
        attributeFilter: ["open"],
      });
    }

    this._ensureMessageHolder = () => {
      let holder = this.querySelector("#return-drawer-message");
      if (!holder) {
        holder = document.createElement("div");
        holder.id = "return-drawer-message";
        holder.setAttribute("aria-live", "polite");

        const fieldset = this._form && this._form.querySelector(".fieldset");
        if (fieldset && fieldset.parentNode) {
          fieldset.parentNode.insertBefore(holder, fieldset.nextSibling);
        } else {
          this.appendChild(holder);
        }
      }
      return holder;
    };

    this._extractMessageHtml = (html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      const success =
        doc.querySelector(".form-status") ||
        doc.querySelector(".contact-form__message") ||
        doc.querySelector(".banner--success") ||
        doc.querySelector('[role="status"]');

      if (success) return { ok: true, html: success.outerHTML };

      const error =
        doc.querySelector(".banner--error") ||
        doc.querySelector(".errors") ||
        doc.querySelector("ul.errors") ||
        doc.querySelector('[role="alert"]');

      if (error) return { ok: false, html: error.outerHTML };

      return {
        ok: true,
        html: '<div class="banner banner--success" role="status">Request received. We will email you the next steps.</div>',
      };
    };

    this._markInvalid = (el) => {
      if (!el) return;
      el.setAttribute("aria-invalid", "true");
    };

    this._clearInvalid = (el) => {
      if (!el) return;
      el.removeAttribute("aria-invalid");
    };

    this._isEmpty = (el) => {
      const v = (el && el.value ? el.value : "").trim();
      return v.length === 0;
    };

    this._getByName = (name) => {
      if (!this._form) return null;

      try {
        return this._form.querySelector(`[name="${CSS.escape(name)}"]`);
      } catch (e) {
        return this._form.querySelector(`[name="${name}"]`);
      }
    };

    this._isValidEmailStrict = (value) => {
      const v = (value || "").trim();

      if (v.length < 6) return false;
      if (v.length > 254) return false;
      if (/\s/.test(v)) return false;

      const parts = v.split("@");
      if (parts.length !== 2) return false;

      const local = parts[0] || "";
      const domain = parts[1] || "";

      if (!local.length || !domain.length) return false;
      if (local.length > 64) return false;

      if (!domain.includes(".")) return false;
      if (domain.startsWith(".") || domain.endsWith(".")) return false;
      if (domain.includes("..")) return false;

      if (!/^[A-Z0-9._%+-]+$/i.test(local)) return false;
      if (!/^[A-Z0-9.-]+$/i.test(domain)) return false;

      const tld = domain.split(".").pop() || "";
      if (tld.length < 2) return false;

      return true;
    };

    this._getSubmitButton = () => {
      if (!this._form) return null;

      const btn =
        this._form.querySelector('button[type="submit"]') ||
        this._form.querySelector('[type="submit"]') ||
        this._form.querySelector(".account-cta");

      return btn || null;
    };

    this._setSubmitDisabled = (disabled) => {
      const btn = this._getSubmitButton();
      if (!btn) return;

      if (disabled) {
        btn.setAttribute("disabled", "");
        btn.setAttribute("aria-disabled", "true");
        btn.setAttribute("tabindex", "-1");
      } else {
        btn.removeAttribute("disabled");
        btn.removeAttribute("aria-disabled");
        btn.removeAttribute("tabindex");
      }
    };

    this._isFormReady = () => {
      if (!this._form) return false;

      const requiredNames = [
        "contact[first_name]",
        "contact[last_name]",
        "contact[email]",
        "contact[order_number]",
        "contact[reason]",
      ];

      for (let i = 0; i < requiredNames.length; i++) {
        const el = this._getByName(requiredNames[i]);
        if (!el) return false;
        if (el.disabled) return false;

        const val = (el.value || "").trim();
        if (val.length === 0) return false;
      }

      const emailEl = this._getByName("contact[email]");
      if (!emailEl) return false;

      const emailVal = (emailEl.value || "").trim();
      if (!this._isValidEmailStrict(emailVal)) return false;

      return true;
    };

    this._syncSubmitState = () => {
      this._setSubmitDisabled(!this._isFormReady());
    };

    this._validate = () => {
      if (!this._form) return false;

      const requiredNames = [
        "contact[first_name]",
        "contact[last_name]",
        "contact[email]",
        "contact[order_number]",
        "contact[reason]",
      ];

      let firstInvalid = null;

      requiredNames.forEach((name) => {
        const el = this._getByName(name);
        if (!el) return;
        if (el.disabled) return;

        const empty = this._isEmpty(el);
        if (empty) {
          this._markInvalid(el);
          if (!firstInvalid) firstInvalid = el;
        } else {
          this._clearInvalid(el);
        }
      });

      const emailEl = this._getByName("contact[email]");
      if (emailEl && !emailEl.disabled) {
        const emailVal = (emailEl.value || "").trim();

        if (emailVal.length === 0) {
          this._markInvalid(emailEl);
          if (!firstInvalid) firstInvalid = emailEl;
        } else if (!this._isValidEmailStrict(emailVal)) {
          this._markInvalid(emailEl);
          if (!firstInvalid) firstInvalid = emailEl;
        } else {
          this._clearInvalid(emailEl);
        }
      }

      this._syncSubmitState();

      if (firstInvalid) {
        if (this._drawer) this._drawer.setAttribute("open", "");
        this.show("start", { instant: true });

        firstInvalid.focus({ preventScroll: true });
        firstInvalid.scrollIntoView({ block: "center", behavior: "smooth" });
        return false;
      }

      return true;
    };

    this._onLiveClear = (e) => {
      const el = e.target;
      if (!el) return;
      if (!el.matches("input, textarea, select")) return;

      const name = el.getAttribute("name") || "";

      const isRelevant =
        name === "contact[first_name]" ||
        name === "contact[last_name]" ||
        name === "contact[email]" ||
        name === "contact[order_number]" ||
        name === "contact[reason]";

      if (!isRelevant) {
        this._syncSubmitState();
        return;
      }

      const val = (el.value || "").trim();

      if (val.length === 0) {
        this._markInvalid(el);
        this._syncSubmitState();
        return;
      }

      if (name === "contact[email]") {
        if (this._isValidEmailStrict(val)) this._clearInvalid(el);
        else this._markInvalid(el);

        this._syncSubmitState();
        return;
      }

      this._clearInvalid(el);
      this._syncSubmitState();
    };

    this._onSubmit = async (e) => {
      if (!this._form) return;

      e.preventDefault();

      if (this._drawer) this._drawer.setAttribute("open", "");

      const holder = this._ensureMessageHolder();
      if (holder) holder.innerHTML = "";

      const ok = this._validate();
      if (!ok) return;

      if (!this._isFormReady()) {
        this._syncSubmitState();
        return;
      }

      this._setSubmitDisabled(true);

      const formData = new FormData(this._form);

      try {
        const res = await fetch(this._form.action, {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Accept": "text/html",
          },
          redirect: "follow",
        });

        const text = await res.text();
        const parsed = this._extractMessageHtml(text);

        if (holder) holder.innerHTML = parsed.html;

        if (this._drawer) this._drawer.setAttribute("open", "");

        if (parsed.ok) {
          [
            "contact[first_name]",
            "contact[last_name]",
            "contact[email]",
            "contact[order_number]",
            "contact[reason]",
          ].forEach((n) => {
            const el = this._getByName(n);
            if (el) this._clearInvalid(el);
          });

          this.show("success", { instant: true });
        } else {
          this.show("start", { instant: true });
        }
      } catch (err) {
        const fallback = this._ensureMessageHolder();
        if (fallback) {
          fallback.innerHTML =
            '<div class="banner banner--error" role="alert">Something went wrong. Please try again.</div>';
        }
        if (this._drawer) this._drawer.setAttribute("open", "");
        this.show("start", { instant: true });
      } finally {
        this._syncSubmitState();
      }
    };

    this._onSubmitClickGuard = (e) => {
      const btn = this._getSubmitButton();
      if (!btn) return;

      const clickedInside =
        e.target === btn ||
        (e.target &&
          e.target.closest &&
          e.target.closest('button[type="submit"], [type="submit"], .account-cta') === btn);

      if (!clickedInside) return;

      if (!this._isFormReady()) {
        e.preventDefault();
        e.stopPropagation();
        this._validate();
        return;
      }
    };

    if (this._form) {
      this._form.addEventListener("submit", this._onSubmit);
      this._form.addEventListener("input", this._onLiveClear, true);
      this._form.addEventListener("change", this._onLiveClear, true);
      this._form.addEventListener("blur", this._onLiveClear, true);
      this._form.addEventListener("click", this._onSubmitClickGuard, true);
    }

    this._syncSubmitState();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClick);
    if (this._observer) this._observer.disconnect();

    if (this._form && this._onSubmit) {
      this._form.removeEventListener("submit", this._onSubmit);
    }

    if (this._form && this._onLiveClear) {
      this._form.removeEventListener("input", this._onLiveClear, true);
      this._form.removeEventListener("change", this._onLiveClear, true);
      this._form.removeEventListener("blur", this._onLiveClear, true);
    }

    if (this._form && this._onSubmitClickGuard) {
      this._form.removeEventListener("click", this._onSubmitClickGuard, true);
    }
  }

  _scheduleInternalReset() {
    this._cancelInternalReset();

    this._closeResetTimer = window.setTimeout(() => {
      if (this._drawer && !this._drawer.hasAttribute("open")) {
        this.show("start", { instant: true });
      }
      this._closeResetTimer = null;
    }, this._closeDelay);
  }

  _cancelInternalReset() {
    if (!this._closeResetTimer) return;
    window.clearTimeout(this._closeResetTimer);
    this._closeResetTimer = null;
  }

  _animateSwap(fromEl, toEl, onMid) {
    if (!fromEl || !toEl || fromEl === toEl) {
      if (typeof onMid === "function") onMid();
      return;
    }

    fromEl.setAttribute("data-panel-state", "leaving");

    window.setTimeout(() => {
      if (typeof onMid === "function") onMid();

      toEl.hidden = false;
      toEl.setAttribute("data-panel-state", "entering");

      window.setTimeout(() => {
        toEl.removeAttribute("data-panel-state");
      }, 20);

      fromEl.hidden = true;
      fromEl.removeAttribute("data-panel-state");
    }, this._duration);
  }

  show(panelId, { instant = false } = {}) {
    const wrap = this.querySelector("#return-start-panel");
    if (!wrap) return;

    const start = wrap.querySelector("#start");
    const policy = wrap.querySelector("#policy");
    const success = wrap.querySelector("#success");

    if (!start || !policy || !success) return;

    const getVisible = () => {
      if (!policy.hidden) return policy;
      if (!success.hidden) return success;
      return start;
    };

    const current = getVisible();

    const target =
      panelId === "policy" ? policy :
      panelId === "success" ? success :
      start;

    if (instant) {
      start.hidden = true;
      policy.hidden = true;
      success.hidden = true;

      target.hidden = false;

      start.removeAttribute("data-panel-state");
      policy.removeAttribute("data-panel-state");
      success.removeAttribute("data-panel-state");
      return;
    }

    if (current === target) return;

    this._animateSwap(current, target, () => {
      start.hidden = true;
      policy.hidden = true;
      success.hidden = true;

      target.hidden = false;
    });
  }
}

if (!window.customElements.get("return-drawer-panels")) {
  window.customElements.define("return-drawer-panels", ReturnDrawerPanels);
}

(() => {
  const openReturnDrawer = (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const href = (link.getAttribute('href') || '').trim();
    const text = (link.textContent || '').trim().toLowerCase();

    const isReturnLink =
      href === "#return" ||
      href === "#return-drawer" ||
      href.includes("make-a-return") ||
      text === "make a return";

    if (!isReturnLink) return;

    const drawer = document.querySelector("#return-drawer");
    if (!drawer) return;

    e.preventDefault();

    drawer.setAttribute("open", "");

    const panels = drawer.querySelector("return-drawer-panels");
    if (panels && typeof panels.show === "function") {
      panels.show("start", { instant: true });
    }
  };

  document.addEventListener("click", openReturnDrawer);
})();


(function () {
  function initLegalTabs() {
    var header = document.getElementById('legal-subheader');
    var panelsRoot = document.getElementById('legal-panels');
    var dropdown = document.getElementById('legal-mobile-dropdown');
    var overlay = document.getElementById('legal-mobile-overlay');
    if (!header || !panelsRoot) return;

    var menuBtn = header.querySelector('[data-legal-menu]');
    var tabs = document.querySelectorAll('#legal-subheader [data-legal-tab]');
    var dropdownTabs = document.querySelectorAll('#legal-mobile-dropdown [data-legal-tab]');
    var panels = panelsRoot.querySelectorAll('[data-legal-panel]');
    var duration = 250;
    var switching = false;

    function closeOpenAccordionsInside(rootEl) {
      if (!rootEl) return;

      rootEl.querySelectorAll('accordion-disclosure.is-open').forEach(function (accordion) {
        var details = accordion.querySelector('details');
        var summary = accordion.querySelector('summary');

        if (details && details.open && summary) {
          summary.click();
        }

        if (details && details.open) {
          details.open = false;
        }

        accordion.classList.remove('is-open');
      });
    }

    function syncOverlayTop() {
      if (!overlay || !dropdown) return;
      if (dropdown.getAttribute('data-open') !== 'true') return;
      var rect = dropdown.getBoundingClientRect();
      overlay.style.top = Math.max(0, Math.round(rect.bottom)) + 'px';
    }

    function setDropdownHeight(px) {
      if (!dropdown) return;
      dropdown.style.setProperty('max-height', px + 'px', 'important');
    }

    function measureDropdownHeight() {
      if (!dropdown) return 0;

      var prev = dropdown.style.getPropertyValue('max-height');
      var prevPrio = dropdown.style.getPropertyPriority('max-height');

      dropdown.style.setProperty('max-height', '9999px', 'important');
      dropdown.offsetHeight;

      var h = dropdown.scrollHeight;

      if (prev) dropdown.style.setProperty('max-height', prev, prevPrio || 'important');
      else dropdown.style.removeProperty('max-height');

      dropdown.offsetHeight;
      return h;
    }

    function openDropdown() {
      if (!dropdown) return;

      dropdown.setAttribute('data-open', 'true');

      setDropdownHeight(0);
      dropdown.offsetHeight;

      var target = measureDropdownHeight();
      setDropdownHeight(target);

      if (overlay) {
        overlay.setAttribute('data-visible', 'true');
        syncOverlayTop();
      }

      document.body.setAttribute('data-legal-nav-open', '');
    }

    function closeDropdown() {
      if (!dropdown) return;

      var current = measureDropdownHeight();
      setDropdownHeight(current);
      dropdown.offsetHeight;

      dropdown.setAttribute('data-open', 'false');
      setDropdownHeight(0);

      if (overlay) {
        overlay.setAttribute('data-visible', 'false');
        overlay.style.top = '';
      }

      document.body.removeAttribute('data-legal-nav-open');
    }

    function toggleDropdown() {
      if (!dropdown) return;
      var isOpen = dropdown.getAttribute('data-open') === 'true';
      if (isOpen) closeDropdown();
      else openDropdown();
    }

    function getPanelByKey(key) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-legal-panel') === key) return panels[i];
      }
      return null;
    }

    function getDefaultKey() {
      if (panels && panels.length) {
        var first = panels[0].getAttribute('data-legal-panel');
        if (first) return first;
      }
      return 'privacy';
    }

    function getKeyFromHash() {
      var hash = window.location.hash.replace('#', '');
      return hash || getDefaultKey();
    }

    function setAllSelected(key) {
      for (var i = 0; i < tabs.length; i++) {
        var activeTab = tabs[i].getAttribute('data-legal-tab') === key;
        tabs[i].setAttribute('aria-selected', activeTab ? 'true' : 'false');
      }

      for (var j = 0; j < dropdownTabs.length; j++) {
        var activeDropTab = dropdownTabs[j].getAttribute('data-legal-tab') === key;
        dropdownTabs[j].setAttribute('aria-selected', activeDropTab ? 'true' : 'false');
      }
    }

    function switchTo(key, updateHash) {
      if (switching) return;

      var next = getPanelByKey(key);
      if (!next) return;

      var current = null;
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-active') === 'true') current = panels[i];
      }

      if (current === next) {
        setAllSelected(key);
        if (updateHash) history.pushState(null, '', '#' + key);
        return;
      }

      switching = true;

      closeOpenAccordionsInside(panelsRoot);

      setAllSelected(key);

      if (updateHash) {
        history.pushState(null, '', '#' + key);
      }

      if (current) {
        current.setAttribute('data-panel-state', 'leaving');
      }

      window.setTimeout(function () {
        if (current) {
          current.setAttribute('data-active', 'false');
          current.removeAttribute('data-panel-state');
        }

        next.setAttribute('data-active', 'true');
        next.setAttribute('data-panel-state', 'entering');

        next.offsetHeight;

        next.setAttribute('data-panel-state', 'active');

        window.setTimeout(function () {
          next.removeAttribute('data-panel-state');
          switching = false;
        }, duration);
      }, duration);
    }

    for (var t = 0; t < tabs.length; t++) {
      tabs[t].addEventListener('click', function () {
        var key = this.getAttribute('data-legal-tab');
        switchTo(key, true);
      });
    }

    for (var d = 0; d < dropdownTabs.length; d++) {
      dropdownTabs[d].addEventListener('click', function () {
        var key = this.getAttribute('data-legal-tab');
        switchTo(key, true);
        closeDropdown();
      });
    }

    if (menuBtn) {
      menuBtn.addEventListener('click', function () {
        toggleDropdown();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeDropdown();
      });
    }

    document.addEventListener('click', function (e) {
      if (!dropdown) return;
      if (dropdown.getAttribute('data-open') !== 'true') return;
      if (header.contains(e.target)) return;
      if (dropdown.contains(e.target)) return;
      if (overlay && overlay.contains(e.target)) return;
      closeDropdown();
    });

    window.addEventListener('resize', function () {
      if (!dropdown) return;
      if (dropdown.getAttribute('data-open') !== 'true') return;
      setDropdownHeight(measureDropdownHeight());
      syncOverlayTop();
    });

    window.addEventListener('scroll', function () {
      syncOverlayTop();
    }, true);

    window.addEventListener('popstate', function () {
      switchTo(getKeyFromHash(), false);
      closeDropdown();
    });

    switchTo(getKeyFromHash(), false);
    closeDropdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLegalTabs);
  } else {
    initLegalTabs();
  }
})();

(function () {
  var root = document.getElementById('privacy-policy-page');
  if (!root) return;

  var desktopMQ = window.matchMedia('(min-width: 1000px)');

  function getScrollTopFor(el) {
    var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    var rectTop = el.getBoundingClientRect().top;
    var scrollTop = (typeof window.getProxyScrollTop === 'function')
      ? window.getProxyScrollTop()
      : (window.scrollY || document.documentElement.scrollTop || 0);
    return Math.max(0, rectTop + scrollTop - headerHeight - 8);
  }

  function openAccordion(acc) {
    if (!acc) return;
    var details = acc.querySelector('details');
    var summary = acc.querySelector('summary');
    if (details && !details.open && summary) {
      summary.click();
    }
  }

  function smoothScrollTo(targetY, duration) {
    var startY = window.scrollY || document.documentElement.scrollTop;
    var distance = targetY - startY;
    var startTime = null;

    function easeInOut(t) {
      return t < 0.5
        ? 2 * t * t
        : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = easeInOut(progress);
      window.scrollTo(0, startY + distance * eased);
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function openAndScroll(targetId) {
    if (!desktopMQ.matches) return;

    var acc = document.getElementById(targetId);
    if (!acc) return;

    openAccordion(acc);

    window.setTimeout(function () {
      var top = getScrollTopFor(acc);
      smoothScrollTo(top, 800);
    }, 260);
  }

  function bindNav() {
    var items = root.querySelectorAll('[data-pp-target]');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function () {
        if (!desktopMQ.matches) return;
        openAndScroll(this.getAttribute('data-pp-target'));
      });
    }
  }

  bindNav();
})();

(function () {
  var root = document.getElementById('terms-of-use-page');
  if (!root) return;

  var desktopMQ = window.matchMedia('(min-width: 1000px)');

  function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function smoothScrollTo(targetY, duration) {
    var startY = getScrollTop();
    var distance = targetY - startY;
    var startTime = null;

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = easeInOut(progress);
      window.scrollTo(0, startY + distance * eased);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function getScrollTopFor(el) {
    var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    var rectTop = el.getBoundingClientRect().top;
    var scrollTop = getScrollTop();
    return Math.max(0, rectTop + scrollTop - headerHeight - 8);
  }

  function openAccordion(acc) {
    if (!acc) return;
    var details = acc.querySelector('details');
    var summary = acc.querySelector('summary');
    if (details && !details.open && summary) {
      summary.click();
    }
  }

  function openAndScroll(targetId) {
    if (!desktopMQ.matches) return;

    var acc = document.getElementById(targetId);
    if (!acc) return;

    openAccordion(acc);

    window.setTimeout(function () {
      var top = getScrollTopFor(acc);
      smoothScrollTo(top, 800);
    }, 260);
  }

  function bindNav() {
    var items = root.querySelectorAll('[data-tou-target]');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function () {
        if (!desktopMQ.matches) return;
        openAndScroll(this.getAttribute('data-tou-target'));
      });
    }
  }

  bindNav();
})();

(function() {
  var root = document.getElementById('accessibility-page');
  if (!root) return;

  var desktopMQ = window.matchMedia('(min-width: 1000px)');

  function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function smoothScrollTo(targetY, duration) {
    var startY = getScrollTop();
    var distance = targetY - startY;
    var startTime = null;

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = easeInOut(progress);
      window.scrollTo(0, startY + distance * eased);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function getScrollTopFor(el) {
    var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    var rectTop = el.getBoundingClientRect().top;
    var scrollTop = getScrollTop();
    return Math.max(0, rectTop + scrollTop - headerHeight - 8);
  }

  function openAccordion(acc) {
    if (!acc) return;
    var details = acc.querySelector('details');
    var summary = acc.querySelector('summary');
    if (details && !details.open && summary) {
      summary.click();
    }
  }

  function openAndScroll(targetId) {
    if (!desktopMQ.matches) return;

    var acc = document.getElementById(targetId);
    if (!acc) return;

    openAccordion(acc);

    window.setTimeout(function() {
      var top = getScrollTopFor(acc);
      smoothScrollTo(top, 800);
    }, 260);
  }

  function bindNav() {
    var items = root.querySelectorAll('[data-acc-target]');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function() {
        if (!desktopMQ.matches) return;
        openAndScroll(this.getAttribute('data-acc-target'));
      });
    }
  }

  bindNav();
})();

(function () {
  var root = document.getElementById('shipping-page');
  if (!root) return;

  var desktopMQ = window.matchMedia('(min-width: 1000px)');

  function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function smoothScrollTo(targetY, duration) {
    var startY = getScrollTop();
    var distance = targetY - startY;
    var startTime = null;

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = easeInOut(progress);
      window.scrollTo(0, startY + distance * eased);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function getScrollTopFor(el) {
    var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    var rectTop = el.getBoundingClientRect().top;
    var scrollTop = getScrollTop();
    return Math.max(0, rectTop + scrollTop - headerHeight - 8);
  }

  function openAccordion(acc) {
    if (!acc) return;
    var details = acc.querySelector('details');
    var summary = acc.querySelector('summary');
    if (details && !details.open && summary) {
      summary.click();
    }
  }

  function openAndScroll(targetId) {
    if (!desktopMQ.matches) return;

    var acc = document.getElementById(targetId);
    if (!acc) return;

    openAccordion(acc);

    window.setTimeout(function () {
      var top = getScrollTopFor(acc);
      smoothScrollTo(top, 800);
    }, 260);
  }

  function bindNav() {
    var items = root.querySelectorAll('[data-ship-target]');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function () {
        if (!desktopMQ.matches) return;
        openAndScroll(this.getAttribute('data-ship-target'));
      });
    }
  }

  bindNav();
})();

(function () {
  var root = document.getElementById('repayment-page');
  if (!root) return;

  var desktopMQ = window.matchMedia('(min-width: 1000px)');

  function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function smoothScrollTo(targetY, duration) {
    var startY = getScrollTop();
    var distance = targetY - startY;
    var startTime = null;

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = easeInOut(progress);
      window.scrollTo(0, startY + distance * eased);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function getScrollTopFor(el) {
    var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    var rectTop = el.getBoundingClientRect().top;
    var scrollTop = getScrollTop();
    return Math.max(0, rectTop + scrollTop - headerHeight - 8);
  }

  function openAccordion(acc) {
    if (!acc) return;
    var details = acc.querySelector('details');
    var summary = acc.querySelector('summary');
    if (details && !details.open && summary) {
      summary.click();
    }
  }

  function openAndScroll(targetId) {
    if (!desktopMQ.matches) return;

    var acc = document.getElementById(targetId);
    if (!acc) return;

    openAccordion(acc);

    window.setTimeout(function () {
      var top = getScrollTopFor(acc);
      smoothScrollTo(top, 800);
    }, 260);
  }

  function bindNav() {
    var items = root.querySelectorAll('[data-rep-target]');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function () {
        if (!desktopMQ.matches) return;
        openAndScroll(this.getAttribute('data-rep-target'));
      });
    }
  }

  bindNav();
})();

(function () {
  var root = document.getElementById('returns-page');
  if (!root) return;

  var desktopMQ = window.matchMedia('(min-width: 1000px)');

  function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function smoothScrollTo(targetY, duration) {
    var startY = getScrollTop();
    var distance = targetY - startY;
    var startTime = null;

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = easeInOut(progress);
      window.scrollTo(0, startY + distance * eased);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function getScrollTopFor(el) {
    var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    var rectTop = el.getBoundingClientRect().top;
    var scrollTop = getScrollTop();
    return Math.max(0, rectTop + scrollTop - headerHeight - 8);
  }

  function openAccordion(acc) {
    if (!acc) return;
    var details = acc.querySelector('details');
    var summary = acc.querySelector('summary');
    if (details && !details.open && summary) {
      summary.click();
    }
  }

  function openAndScroll(targetId) {
    if (!desktopMQ.matches) return;

    var acc = document.getElementById(targetId);
    if (!acc) return;

    openAccordion(acc);

    window.setTimeout(function () {
      var top = getScrollTopFor(acc);
      smoothScrollTo(top, 800);
    }, 260);
  }

  function bindNav() {
    var items = root.querySelectorAll('[data-ret-target]');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function () {
        if (!desktopMQ.matches) return;
        openAndScroll(this.getAttribute('data-ret-target'));
      });
    }
  }

  bindNav();
})();

document.addEventListener('DOMContentLoaded', function() {
  // =========================
  // CHANGE: scroll-to-top uses fixed 800ms easing (works with proxy scroll too)
  // =========================
  function getScrollTop() {
    if (typeof window.getProxyScrollTop === 'function') {
      return window.getProxyScrollTop();
    }
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function scrollToY(y) {
    if (typeof window.scrollProxyTo === 'function') {
      window.scrollProxyTo(y, 'auto');
    } else {
      window.scrollTo(0, y);
    }
  }

  function smoothScrollTo(targetY, duration) {
    var startY = getScrollTop();
    var distance = targetY - startY;
    var startTime = null;

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = easeInOut(progress);
      scrollToY(startY + distance * eased);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function scrollToTop() {
    smoothScrollTo(0, 800);
  }

  let isScrolling = false;
  let lastScrollTime = 0;
  const SCROLL_COOLDOWN = 500;

  function throttleScroll() {
    const now = Date.now();
    if (isScrolling || (now - lastScrollTime) < SCROLL_COOLDOWN) {
      return false;
    }
    isScrolling = true;
    lastScrollTime = now;

    scrollToTop();

    setTimeout(() => {
      isScrolling = false;
    }, 100);

    return true;
  }

  const allTabs = document.querySelectorAll('[data-legal-tab]');
  const mobileMenuButton = document.querySelector('[data-legal-menu]');
  const mobileDropdown = document.querySelector('[data-legal-dropdown]');
  const mobileOverlay = document.querySelector('[data-legal-overlay]');

  allTabs.forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();

      throttleScroll();

      if (mobileDropdown && mobileDropdown.getAttribute('data-open') === 'true') {
        mobileDropdown.setAttribute('data-open', 'false');
        if (mobileOverlay) {
          mobileOverlay.setAttribute('data-visible', 'false');
        }
      }
    });
  });

  if (mobileMenuButton) {
    mobileMenuButton.addEventListener('click', function() {
      if (mobileDropdown && mobileDropdown.getAttribute('data-open') === 'true') {
        const activeTab = document.querySelector('[data-legal-tab][aria-selected="true"]');
        if (activeTab) {
          throttleScroll();
        }
      }
    });
  }

  let lastHash = window.location.hash;
  window.addEventListener('hashchange', function() {
    const currentHash = window.location.hash;

    if (currentHash === lastHash) {
      setTimeout(() => throttleScroll(), 100);
    } else {
      lastHash = currentHash;
      setTimeout(() => throttleScroll(), 100);
    }
  });

  if (window.location.hash) {
    setTimeout(() => throttleScroll(), 300);
  }

  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (link && link.hash) {
      const hash = link.hash;

      if (link.closest('#account-drawer')) return;

      const isSamePage =
        link.origin === window.location.origin &&
        link.pathname === window.location.pathname;

      if (!isSamePage) return;

      const isOnLegalPage = window.location.pathname.includes('legal-privacy') ||
                            document.querySelector('#legal-subheader');

      if (isOnLegalPage) {
        e.preventDefault();
        window.location.hash = hash;
        setTimeout(() => throttleScroll(), 50);
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const setCounts = () => {
    document.querySelectorAll("carousel-navigation.scroll-marker-group--lines").forEach((nav) => {
      const count = nav.querySelectorAll("button.scroll-marker:not([hidden])").length
      nav.style.setProperty("--line-count", count)
    })
  }

  setCounts()
  window.addEventListener("resize", setCounts)
});


document.addEventListener("click", (e) => {
  const btn = e.target.closest(".lp-faq-jump");
  if (!btn) return;

  e.preventDefault();

  const code = (btn.getAttribute("data-featured-question") || "").trim();
  if (!code) return;

  const main = code.split(".")[0];

  const themeByMain = {
    "1": "corporate-information",
    "2": "delivery",
    "3": "exchange-returns",
    "4": "orders",
    "5": "products",
    "6": "services"
  };

  const theme = themeByMain[main];
  if (!theme) return;

  const start = document.getElementById("lp-faqs-start");
  const detail = document.getElementById("lp-faqs-detail");

  if (start) start.setAttribute("data-active", "false");
  if (detail) detail.setAttribute("data-active", "true");

  const detailTab =
    document.querySelector('#lp-themes-grid-detail [data-theme-tab="' + theme + '"]') ||
    document.querySelector('[data-theme-tab="' + theme + '"]');

  if (detailTab) detailTab.click();

  requestAnimationFrame(() => {
    const panel = document.querySelector('#lp-theme-detail-panels [data-theme-panel="' + theme + '"]');
    if (!panel) return;

    const accordions = Array.from(panel.querySelectorAll("accordion-disclosure"));

    const targetAccordion = accordions.find((acc) => {
      const titleEl = acc.querySelector("summary span");
      const t = titleEl ? titleEl.textContent.trim() : "";
      return t.startsWith(code);
    });

    if (!targetAccordion) return;

    const summary = targetAccordion.querySelector("summary");
    if (summary) summary.click();

    targetAccordion.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

function isLvMode() {
  return window.matchMedia("(min-width: 1250px)").matches;
}

function getLvDepth(panelId) {
  if (!panelId || panelId === 'menu-drawer-panel-main') return 0;
  var parts = panelId.replace('menu-drawer-panel-', '').split('-');
  return parts.length;
}

(function() {
  var checkReady = setInterval(function() {
    var drawer = document.querySelector('header-menu-drawer');
    if (!drawer) return;
    clearInterval(checkReady);

    drawer.querySelectorAll('header-menu-drawer-panel').forEach(function(panel) {
      var depth = getLvDepth(panel.id);
      if (depth === 1) {
        panel.classList.add('lv-depth-1');
      }
    });

    var _busy = false;
    var _slotPanels = [null, null, null];

    function getSlotForDepth(depth) {
      if (depth <= 0) return 0;
      if (depth === 1) return 1;
      return 2;
    }

    function getBody(panel) {
      return panel.querySelector('.menu-drawer__panel-body');
    }

    function getChildren(panel) {
      var body = getBody(panel);
      var list = [];
      if (body) {
        body.querySelectorAll(':scope > *').forEach(function(k) { list.push(k); });
      }
      var footer = panel.querySelector('.menu-drawer__panel-footer');
      if (footer) list.push(footer);
      return list;
    }

    function hideChildren(panel) {
      getChildren(panel).forEach(function(child) {
        child.style.opacity = '0';
        child.style.visibility = 'hidden';
      });
    }

    function resetChildren(panel) {
      getChildren(panel).forEach(function(child) {
        child.style.opacity = '';
        child.style.visibility = '';
        child.getAnimations().forEach(function(a) { a.cancel(); });
      });
    }

    function updatePanelDimming() {
      drawer.querySelectorAll('header-menu-drawer-panel').forEach(function(panel) {
        panel.classList.remove('lv-has-child-open');
      });
      if (_slotPanels[1]) {
        var mainPanel = _slotPanels[0];
        if (mainPanel) mainPanel.classList.add('lv-has-child-open');
      }
      if (_slotPanels[2]) {
        var subPanel = _slotPanels[1];
        if (subPanel) subPanel.classList.add('lv-has-child-open');
      }
    }

    function clearActiveInPanel(panel) {
      if (!panel) return;
      panel.querySelectorAll('.lv-parent-active').forEach(function(el) {
        el.classList.remove('lv-parent-active');
      });
    }

    function waitAnim(anim) {
      return new Promise(function(resolve) {
        anim.onfinish = resolve;
        anim.oncancel = resolve;
      });
    }

    function fadeInChildren(panel) {
      var children = getChildren(panel);
      if (!children.length) return Promise.resolve();
      children.forEach(function(child) {
        child.style.visibility = '';
        child.style.opacity = '0';
      });
      var proms = [];
      children.forEach(function(child) {
        var a = child.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration: 200, easing: 'ease-in-out', fill: 'forwards' }
        );
        proms.push(waitAnim(a));
      });
      return Promise.all(proms).then(function() {
        children.forEach(function(child) {
          child.style.opacity = '';
          child.style.visibility = '';
          child.getAnimations().forEach(function(a) { a.cancel(); });
        });
      });
    }

    function fadeOutChildren(panel) {
      var children = getChildren(panel);
      if (!children.length) return Promise.resolve();
      var proms = [];
      children.forEach(function(child) {
        var a = child.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: 200, easing: 'ease-in-out', fill: 'forwards' }
        );
        proms.push(waitAnim(a));
      });
      return Promise.all(proms).then(function() {
        children.forEach(function(child) {
          child.style.opacity = '0';
          child.style.visibility = 'hidden';
        });
      });
    }

    function slideInPanel(panel) {
      panel.classList.add('is-visible');
      hideChildren(panel);

      var a = panel.animate(
        [
          { transform: 'translateX(-100%)', width: '0px', minWidth: '0px', flex: '0 0 0px' },
          { transform: 'translateX(0)', width: '33.333vw', minWidth: '0px', flex: '0 0 33.333vw' }
        ],
        { duration: 450, easing: 'cubic-bezier(0.86, 0, 0.07, 1)', fill: 'forwards' }
      );

      return waitAnim(a).then(function() {
        panel.getAnimations().forEach(function(an) { an.cancel(); });
        panel.style.transform = '';
        panel.style.width = '';
        panel.style.minWidth = '';
        panel.style.flex = '';
        return fadeInChildren(panel);
      });
    }

    function slideOutPanel(panel) {
      return fadeOutChildren(panel).then(function() {
        var a = panel.animate(
          [
            { transform: 'translateX(0)', width: '33.333vw', minWidth: '0px', flex: '0 0 33.333vw' },
            { transform: 'translateX(-100%)', width: '0px', minWidth: '0px', flex: '0 0 0px' }
          ],
          { duration: 450, easing: 'cubic-bezier(0.86, 0, 0.07, 1)', fill: 'forwards' }
        );

        return waitAnim(a).then(function() {
          panel.getAnimations().forEach(function(an) { an.cancel(); });
          panel.classList.remove('is-visible');
          panel.style.transform = '';
          panel.style.width = '';
          panel.style.minWidth = '';
          panel.style.flex = '';
          resetChildren(panel);
        });
      });
    }

    function swapContent(oldPanel, newPanel) {
      return fadeOutChildren(oldPanel).then(function() {
        oldPanel.classList.remove('is-visible');
        oldPanel.style = '';
        resetChildren(oldPanel);

        newPanel.classList.add('is-visible');
        hideChildren(newPanel);

        return fadeInChildren(newPanel);
      });
    }

    function swapPanelInSlot(slot, newPanel) {
      var oldPanel = _slotPanels[slot];

      if (oldPanel && oldPanel === newPanel) return Promise.resolve();

      if (oldPanel && newPanel) {
        _slotPanels[slot] = newPanel;
        return swapContent(oldPanel, newPanel);
      }

      if (!oldPanel && newPanel) {
        _slotPanels[slot] = newPanel;
        return slideInPanel(newPanel);
      }

      if (oldPanel && !newPanel) {
        _slotPanels[slot] = null;
        return slideOutPanel(oldPanel);
      }

      return Promise.resolve();
    }

    drawer.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-panel-toggle]');
      if (!toggle) return;
      if (!isLvMode()) return;
      if (toggle.classList.contains('back-button')) return;

      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();

      if (_busy) return;

      var panelId = toggle.getAttribute('aria-controls');
      if (!panelId) return;

      var toPanel = drawer.querySelector('#' + panelId);
      if (!toPanel) return;

      var targetDepth = getLvDepth(panelId);
      var targetSlot = getSlotForDepth(targetDepth);

      if (_slotPanels[targetSlot] === toPanel) return;

      _busy = true;

      var parentPanel = toggle.closest('header-menu-drawer-panel');
      clearActiveInPanel(parentPanel);
      toggle.classList.add('lv-parent-active');

      var promises = [];
      promises.push(swapPanelInSlot(targetSlot, toPanel));

      for (var s = targetSlot + 1; s <= 2; s++) {
        if (_slotPanels[s]) {
          promises.push(swapPanelInSlot(s, null));
        }
      }

      Promise.all(promises).then(function() {
        updatePanelDimming();
        _busy = false;
      });

    }, true);

    drawer.addEventListener('dialog:before-show', function() {
      if (!isLvMode()) return;
      _slotPanels = [null, null, null];
      drawer.querySelectorAll('header-menu-drawer-panel').forEach(function(panel) {
        panel.classList.remove('lv-has-child-open');
      });
      var mainPanel = drawer.querySelector('#menu-drawer-panel-main');
      if (mainPanel) {
        _slotPanels[0] = mainPanel;
        mainPanel.classList.add('is-visible');
      }
    });

    drawer.addEventListener('dialog:after-hide', function() {
      if (!isLvMode()) return;
      _slotPanels = [null, null, null];
      drawer.querySelectorAll('header-menu-drawer-panel').forEach(function(panel) {
        panel.classList.remove('is-visible', 'lv-has-child-open');
        panel.style = '';
        panel.getAnimations().forEach(function(a) { a.cancel(); });
        resetChildren(panel);
      });
      drawer.querySelectorAll('.lv-parent-active').forEach(function(el) {
        el.classList.remove('lv-parent-active');
      });
    });

  }, 100);
})();

(function(){
  function normalizeAddressLines(scope){
    var root = scope || document;
    var nodes = root.querySelectorAll('#customer-account-wrapper .address p');
    nodes.forEach(function(p){
      if (p.getAttribute('data-address-lines') === '1') return;
      if (!p.querySelector('br')) return;

      var html = p.innerHTML;
      html = html.replace(/<br\s*\/?>/gi, '\n');
      var lines = html.split('\n').map(function(s){ return s.replace(/^\s+|\s+$/g,''); }).filter(Boolean);

      p.textContent = '';
      p.setAttribute('data-address-lines','1');

      lines.forEach(function(line){
        var span = document.createElement('span');
        span.className = 'address-line';
        span.textContent = line;
        p.appendChild(span);
      });
    });
  }

  function init(){
    normalizeAddressLines(document);

    var wrapper = document.getElementById('customer-account-wrapper');
    if (!wrapper) return;

    var mo = new MutationObserver(function(){
      normalizeAddressLines(wrapper);
    });

    mo.observe(wrapper, { childList:true, subtree:true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

(function () {
  let gorgiasLoaded = false;

  function loadGorgias() {
    if (gorgiasLoaded) {
      // Al geladen, alleen openen
      if (window.GorgiasChat) {
        window.GorgiasChat.open();
      }
      return;
    }
    gorgiasLoaded = true;

    const script = document.createElement('script');
    script.id = 'gorgias-chat-widget-install-v3';
    script.src = 'https://config.gorgias.chat/bundle-loader/01KK9HAT38P1BEH56VKF4DR4Z9';
    script.onload = function () {
      // Wacht tot Gorgias klaar is, dan open
      const check = setInterval(function () {
        if (window.GorgiasChat) {
          clearInterval(check);
          window.GorgiasChat.open();
        }
      }, 200);
    };
    document.body.appendChild(script);
  }

  // Verberg de standaard bubble/launcher zodra Gorgias laadt
  function hideLauncher() {
    const style = document.createElement('style');
    style.textContent = `
      #gorgias-chat-container iframe[title="Gorgias Chat Messenger"],
      #gorgias-chat-container iframe[title="Chat Button"] {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  hideLauncher();

  // Klik-handler
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'open-live-chat') {
      e.preventDefault();
      loadGorgias();
    }
  });

  // Verberg weer als chat wordt gesloten
  const observer = new MutationObserver(function () {
    if (window.GorgiasChat) {
      // Luister naar close-event via Gorgias API
      window.GorgiasChat.on('widget:closed', function () {
        // Verberg het chatvenster weer
        const container = document.getElementById('gorgias-chat-container');
        if (container) {
          container.style.display = 'none';
        }
      });
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Scroll to reviews
document.addEventListener('click', function(e) {
  if (e.target.closest('.scroll-to-reviews')) {
    
    // Zoek de reviews sectie generiek — zonder hardcoded ID
    var target = document.querySelector('[id*="ss_testimonials"]') || 
                 document.querySelector('[id*="testimonials"]');
    
    if (target) {
      var headerHeight = parseInt(
        getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height')
      ) || 0;

      if (typeof window.scrollProxyTo === 'function') {
        var shell = document.querySelector('.mobile-scroll-shell');
        var shellScrollTop = shell ? shell.scrollTop : 0;
        var y = target.getBoundingClientRect().top + shellScrollTop - headerHeight;
        window.scrollProxyTo(y, 'smooth');
      } else {
        var y = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }
});